import { ClassSessionType } from "components/server-types";

export const isClassSessionActive = (classSession: ClassSessionType) => {
  return !!classSession.started_at && classSession.ended_at === null;
};

export const getActiveClassSession = (
  classSessions: ClassSessionType[],
  sectionId: string | null,
) => {
  if (!sectionId) return null;
  const activeClassSessions = classSessions.filter(
    (cs) => cs.section_id === sectionId && isClassSessionActive(cs),
  );
  if (activeClassSessions.length === 0) {
    return null;
  }
  // Sort by started_at descending (most recent first) and return the first one
  return activeClassSessions.sort((a, b) => {
    const aStarted = new Date(a.started_at!).getTime();
    const bStarted = new Date(b.started_at!).getTime();
    return bStarted - aStarted;
  })[0];
};
